module.exports = __webpack_public_path__ + "static/media/3.c350b443.jpg";